export enum VendorTypes {
  Business = "business",
  Agent = "agent",
}
